import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + "/api/users/";

const getAllUsers = async () => {
  return await axios.get(API_URL + "all");
};

export { getAllUsers };
